module.exports = __webpack_public_path__ + "static/media/not_found.732df2a0.jpg";